import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator'; // Optional: for visual separation

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-6 mt-12">
      <div className="container px-4 text-center">
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-4 text-sm">
          <Link to="/about" className="hover:text-gray-300 transition-colors">
            About Bheda Kasam
          </Link>
        </div>
        <Separator className="bg-gray-700 mb-4" />
        <p className="text-xs text-gray-400">
          भेडा कसम &copy; {new Date().getFullYear()} | Holding Politicians Accountable
        </p>
      </div>
    </footer>
  );
};

export default Footer; 